export const loadItemFromLocalStorage = <T>(name: string): T | undefined => {
  try {
    const serialziedState = localStorage.getItem(name);

    return serialziedState ? JSON.parse(serialziedState) : undefined;
  } catch (err) {
    return undefined;
  }
};

export const saveItemToLocalStorage = (name: string, state): boolean => {
  try {
    localStorage.setItem(name, JSON.stringify(state));

    return true;
  } catch (err) {
    // ignoring write errors for the time being
    return false;
  }
};
